<template>
  <v-dialog v-model="dialog" lazy persistent fullscreen hide-overlay>
    <v-card color="#efefef">
      <v-toolbar dark color="#7d3dff">
        <v-btn icon dark @click="showSaveLeadModal">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text">Vendas</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-layout row class="mt-0">
        <!-- Formulário de Cadastro de Novos Clientes -->
        <v-flex sm9>
          <CustomerForm
            :updateComponent="updateComponent"
            @closeDialog="closeDialog"
            @showStatusSaleSnack="showStatusSaleSnack"
            @clearForm="clearForm"
          />
        </v-flex>

        <!-- Simulador -->
        <v-flex sm3 class="simulador mt-0">
          <SimulatorForm />
        </v-flex>
      </v-layout>
    </v-card>
    <save-lead-modal
      :showDialog="showSaveLead"
      :closeView="closeView"
      @clearForm="clearForm()"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CustomerForm from "./form/CustomerForm.vue";
import SaveLeadModal from "./form/SaveLeadModal.vue";
import SimulatorForm from "./simulator/SimulatorForm.vue";

export default {
  name: "SaleView",

  components: { CustomerForm, SimulatorForm, SaveLeadModal },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState("sales", ["plans", "isCorreios"]),
  },

  async mounted() {
    if (!this.plans || this.plans.length <= 0) {
      await this.getAllPlans();
    }
  },

  data: () => ({
    showSaveLead: false,
    updateComponent: 1,
  }),

  methods: {
    ...mapActions("sales", ["getAllPlans"]),
    ...mapMutations("sales", ["resetOtherState", "setIsCorreios", "setSeller"]),
    ...mapMutations("qualification", ["setQualifications"]),
    showSaveLeadModal() {
      this.showSaveLead = !this.showSaveLead;
    },
    closeView() {
      this.showSaveLead = !this.showSaveLead;
      this.closeDialog();
    },
    closeDialog() {
      this.clearForm();
      this.$emit("closeDialog");
    },
    Qualificar() {
      this.$emit("openQualificar");
    },
    clearForm() {
      this.setIsCorreios(false);
      this.resetOtherState();
      this.setQualifications([]);
      this.setSeller(null);
      this.updateComponent++;
    },
    showStatusSaleSnack(status, text) {
      this.$emit("showStatusSaleSnack", status, text);
    },
  },
};
</script>
